import { useLocation } from "react-router-dom";
import { useState } from "react";
import allProducts from "./allproducts";
import SubCardDetail from '../src/Occasions/SubCardDetail';
import { useCart } from "./Cart/Cart"; 
import { toast } from 'react-toastify';


function useQuery() {
  
  return new URLSearchParams(useLocation().search);
}

const SearchResults = () => {
  const query = useQuery();
  const searchTerm = (query.get("q") || "").toLowerCase();

  const [selectedBooking, setSelectedBooking] = useState(null);
  
const { addToCart } = useCart();

  const results = allProducts.filter(item =>
    item.title.toLowerCase().includes(searchTerm) ||
    (item.description && item.description.toLowerCase().includes(searchTerm)) ||
    (item.price && item.price.toString().includes(searchTerm)) ||
    (item.category && item.category.toLowerCase().includes(searchTerm))
    );


  if (selectedBooking){
    return(
      <SubCardDetail
      card={selectedBooking}
      onBack={() => setSelectedBooking(null)}
      />
    )
  }
  
  return (
    <div className="search-results-container">
      <h2>Search Results</h2>
      <p>
        Showing results for: <strong>{searchTerm}</strong>
      </p>
      {results.length === 0 ? (
        <p>No results found.</p>
      ) : (
         <div className="card-container">
        
               { results.map((item, idx) => (
                 <div 
          className="card" 
          key={idx}
          onClick={() => setSelectedBooking(item)}
          style={{ cursor: "pointer" }}
        >
          <img src={item.image} alt={item.title} />
          <div className="card-content">
            <p className="card-title">{item.title}</p>
            <p className="price">₹{item.price.toLocaleString()}</p>
            <button
              className="add-to-cart-btn"
              onClick={(e) => {
                e.stopPropagation(); 
                addToCart({ ...item, quantity: 1 });
                toast.success('Item added to your cart!');
              }}
            >
              Add to Cart
            </button>
          </div>
        </div>
                  
                ))}
              </div>
      )}
    </div>
  );
};

export default SearchResults;
